import { Route, Routes } from 'react-router-dom';
import Home from './Views/Home';
import Services from './Views/Services';
import NotFound from './Views/NotFound';
import About from './Views/About';
import ContactUs from './Views/ContactUs';
import Automation from './Components/Automation';
import Robotic from './Components/Robotic';
import RoboticCards from './Components/RoboticCards';
import Printing from './Views/3D-Printing';
import ourservices from './Components/OurServices1';
import warehouse from './Views/Warehouse';
import precise from './Views/Precise';
import Sheetmetal from './Views/Sheetmetal';
import Scanning from './Views/3D-Scanning';
import DesignAndConsultation from './Views/DesignAndConsultation';
import Products from './Views/Products';
import Career from './Views/Career';
import Capabilities from './Components/Capabilities';
import TermsOfService from './Views/TermsOfService';
import PrivacyPolicy from './Views/PrivacyPolicy';
import CookiePolicy from './Views/CookiePolicy';

function Routers() {
  return (
    <Routes>
      <Route path='*' element={<NotFound />} />
      <Route path='/' element={<Home />} />
      <Route path='/services' element={<Services />} />
      <Route path='/about' element={<About />} />
      <Route path='/ContactUs' element={<ContactUs />} />
      <Route path='/Automation' element={<Automation />} />
      <Route path='/Robotic' element={<Robotic />} />
      <Route path='/RoboticCards' element={<RoboticCards />} />
      <Route path='/Printing' element={<Printing />} />
      <Route path='/ourservices' element={<ourservices />} />
      <Route path='/Warehouse' element={<warehouse />} />
      <Route path='/Precise' element={<precise />} />
      <Route path='/Sheetmetal' element={<Sheetmetal />} />
      <Route path='/Scanning' element={<Scanning />} />
      <Route path='/DesignAndConsultation' element={<DesignAndConsultation />} />
      <Route path='/Products' element={<Products />} />
      <Route path='/Career' element={<Career />} />
      <Route path='/Capabilities' element={<Capabilities />} />
      <Route path='/TermsOfService' element={<TermsOfService />} />
<Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />   
<Route path='/CookiePolicy' element={<CookiePolicy />} />   

    </Routes>
  );
}

export default Routers;
